import { ApplicationState } from 'application/redux';
import { clearAllFilters } from 'core/multiple-search/redux/action';
import { executeCommand } from 'core/utils/deviceUtils';
import { connect } from 'react-redux';
import { clearAccordionTable } from '../../../../../core/table-accordion/redux/actions';
import DvrComponent from './dvr-component';
import { clearCacheDvr, deleteRecording, fetch, getTimelineRecordings, toggleTimeline } from './redux/actions';

function mapStateToProps(state: ApplicationState, ownProps: any) {
  return {
    dvr: state.devices.detail.dvr,
    general: state.devices.detail.general,
    hhid: ownProps.hhid,
    id: ownProps.id,
    t: state.i18n.t,
    offset: state.application.offset
  };
}

export default connect(mapStateToProps, {
  deleteRecording,
  fetch,
  clearAccordionTable,
  getTimelineRecordings,
  toggleTimeline,
  executeCommand,
  clearAllFilters,
  clearCacheDvr,
})(DvrComponent);
